import moment from 'moment-timezone';

export function formatDateTimeBR(date: Date | any) {
  if (!date) return;

  return moment(new Date(`${date}Z`))
    .tz('America/Fortaleza')
    .format('DD/MM/YYYY [às] HH:mm');
}
